import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'ble_options',
  title: 'Параметры BLE-меток',
  apiType: apiTypes.ALT_NAV_API,
  elemsOnPage: 100,
  connections: {
    bledevicestype: {
      apiType: apiTypes.ALT_NAV_API,
      table: 'ble_devices_type',
      fields: ['name_type'],
      format: (elem: any) => elem['name_type'],
      index: 'id',
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'device_type_id',
      title: 'Тип',
      type: 'text',
      width: '200px',
      required: true,
      connection: 'bledevicestype',
    },
    {
      name: 'version',
      title: 'Версия протокола',
      type: 'number',
    },
    {
      name: 'key',
      title: 'Ключ',
      type: 'text',
    },
    {
      name: 'mac_fixed_mask',
      title: 'Фиксированная маска MAC-адреса',
      type: 'text',
      required: true,
    },
    {
      name: 'mac_fixed_value',
      title: 'Фиксированное значение МАС-адреса',
      type: 'text',
      required: true,
    },
    {
      name: 'R0a',
      title: 'R0a',
      type: 'number',
    },
    {
      name: 'R0b',
      title: 'R0b',
      type: 'number',
    },
    {
      name: 'R0c',
      title: 'R0c',
      type: 'number',
    },
    {
      name: 'R1a',
      title: 'R1a',
      type: 'number',
    },
    {
      name: 'R1b',
      title: 'R1b',
      type: 'number',
    },
    {
      name: 'R1c',
      title: 'R1c',
      type: 'number',
    },
    {
      name: 'R2a',
      title: 'R2a',
      type: 'number',
    },
    {
      name: 'R2b',
      title: 'R2b',
      type: 'number',
    },
    {
      name: 'R2c',
      title: 'R2c',
      type: 'number',
    },
    {
      name: 'R3a',
      title: 'R3a',
      type: 'number',
    },
    {
      name: 'R3b',
      title: 'R3b',
      type: 'number',
    },
    {
      name: 'R3c',
      title: 'R3c',
      type: 'number',
    },
  ],
  newTemplate: {
    device_type_id: null,
    version: '',
    key: '',
    mac_fixed_mask: '',
    mac_fixed_value: '',
    R0a: null,
    R0b: null,
    R0c: null,
    R1a: null,
    R1b: null,
    R1c: null,
    R2a: null,
    R2b: null,
    R2c: null,
    R3a: null,
    R3b: null,
    R3c: null,
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'id',
        field: 'id'
      },
      {
        title: 'device_type_id',
        field: 'device_type_id'
      },
      {
        title: 'mac_fixed_mask',
        field: 'mac_fixed_mask'
      },
      {
        title: 'mac_fixed_value',
        field: 'mac_fixed_value'
      },
      {
        title: 'R0a',
        field: 'R0a'
      },
      {
        title: 'R0b',
        field: 'R0b'
      },
      {
        title: 'R0c',
        field: 'R0c'
      },
      {
        title: 'R1a',
        field: 'R1a'
      },
      {
        title: 'R1b',
        field: 'R1b'
      },
      {
        title: 'R1c',
        field: 'R1c'
      },
      {
        title: 'R2a',
        field: 'R2a'
      },
      {
        title: 'R2b',
        field: 'R2b'
      },
      {
        title: 'R2c',
        field: 'R2c'
      },
      {
        title: 'R3a',
        field: 'R3a'
      },
      {
        title: 'R3b',
        field: 'R3b'
      },
      {
        title: 'R3c',
        field: 'R3c'
      },
    ],
    example: `1;1;0x1;0xFF;00:00:00;9;9;9;9;9;9;9;9;9;9;9;9`
  }
};

export default config;